import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SUPPORT_EMAIL, Section, WHATSAPP_LABEL, WHATSAPP_URL } from './Shared';
import { FretDivider } from './Ornaments';
export function Guarantee() {
  return <Section className="max-w-3xl" data-id="element-76" data-mp="32onll67cnuaj">
      <div className="paper-card rounded-sm border border-brand-forest/35 p-8 text-center shadow-[0_12px_34px_rgba(44,38,32,0.08)] md:p-12" data-id="element-77" data-mp="32pp601a99t4x">
        <ShieldCheckIcon className="mx-auto h-14 w-14 text-brand-forest" aria-hidden="true" data-id="element-78" data-mp="3ufa6wespvjq0" />
        <h2 className="mt-5 font-display text-3xl font-bold text-brand-ink" data-id="element-79" data-mp="38h2z36jh6hs">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>
        <FretDivider character="信" className="mt-5" data-id="element-80" data-mp="3ldaopj5yu9lh" />
        <p className="mt-5 text-brand-text" data-id="element-81" data-mp="3qdf5796vj4bp">
          Descargás el Atlas. Abrís el Tomo II. Lo usás en tu próxima sesión
          clínica.
        </p>
        <p className="mt-4 text-brand-text" data-id="element-82" data-mp="29ydxq3q81abh">
          Si en 7 días no es exactamente lo que esperabas: devolución del 100%
          sin formularios, sin drama, sin preguntas.
        </p>
        <p className="mt-6 font-semibold text-brand-forest" data-id="element-83" data-mp="3lalgfg6ys7uh">
          Tasa de devoluciones: menos del 1%.
        </p>
      </div>
    </Section>;
}
export function Footer() {
  return <footer className="border-t border-brand-gold/40 bg-brand-ink py-12 text-brand-paper" data-id="element-84" data-mp="3v89dwdvyftgc">
      <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8" data-id="element-85" data-mp="3q8wu620dr2hz">
        <p className="font-kanji text-2xl text-brand-goldLight/70" aria-hidden="true" data-id="element-86" data-mp="3qazp90ge3ltk">
          針灸
        </p>
        <h3 className="mt-2 font-display text-3xl font-bold tracking-[0.06em] text-brand-goldLight" data-id="element-87" data-mp="33xge4qruavo">
          LUMEN AKASHA™
        </h3>
        <p className="mx-auto mt-3 max-w-2xl text-white/80" data-id="element-88" data-mp="hrs75fl7y564">
          El sistema visual de acupuntura clínica N°1 para terapeutas en
          Argentina.
        </p>
        <p className="mx-auto mt-2 max-w-2xl text-white/70" data-id="element-89" data-mp="qt8h5m84g59t">
          Porque aplicar Medicina Tradicional China con excelencia no debería
          depender de cuánto recordás ese día.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 text-sm text-brand-goldLight sm:flex-row sm:gap-7" data-id="element-90" data-mp="tvd13wd6udh9">
          <a className="transition-colors hover:text-brand-paper" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-91" data-mp="yv92dnui3qt4">
            📧 {SUPPORT_EMAIL}
          </a>
          <a className="transition-colors hover:text-brand-paper" href={WHATSAPP_URL} data-id="element-92" data-mp="13rfzqs8tztzg">
            📱 WhatsApp: {WHATSAPP_LABEL}
          </a>
          <a className="transition-colors hover:text-brand-paper" href="https://instagram.com/lumen.akasha" data-id="element-93" data-mp="1cmdu83rmnesw">
            📷 @lumen.akasha
          </a>
          <a className="transition-colors hover:text-brand-paper" href="https://www.lumenakasha.com" data-id="element-94" data-mp="1hms31o11ysrz">
            🌐 www.lumenakasha.com
          </a>
        </div>
        <div className="mt-10 space-y-2 text-xs text-white/50" data-id="element-95" data-mp="1rhk4j2xr9zs1">
          <p data-id="element-96" data-mp="3obexrtubnece">
            © Lumen Akasha™ 2026 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
          <p data-id="element-97" data-mp="3tc2veyd22tfl">
            Ley 25.326 — Protección de Datos Personales — República Argentina
          </p>
        </div>
        <p className="mt-8 font-display text-sm italic text-brand-goldLight/75" data-id="element-98" data-mp="25onclybtj3tk">
          “El terapeuta que tiene un sistema aplica con confianza. El que aplica
          con confianza genera resultados. El que genera resultados crece.”
        </p>
      </div>
    </footer>;
}